import MoreFilters from './MoreFilters';
import { connect } from 'react-redux';
import { getCheckedOptionsMap, getSearchParameters } from '../../../../state';
import {
    checkFacetOption,
    clearManyFacetOptions,
    selectFacetOption,
    uncheckFacetOption,
} from '../../../../actions/facets';
import {
    trackFilterClickAdditionalCriteria,
    trackFilterClickHospitalAffiliations,
    trackFilterClickLanguage,
    trackFilterClickSpecialHours,
    trackMoreFiltersClick,
} from '../../../../actions';

const mapStatetoProps = state => {
    return {
        appliedOptionsMap: getSearchParameters(state).filters,
        checkedOptionsMap: getCheckedOptionsMap(state),
    };
};

const mapDispatchToProps = {
    onApplyLanguages: trackFilterClickLanguage,
    onApplySeesChildren: trackFilterClickAdditionalCriteria,
    onApplyHospitalAffiliations: trackFilterClickHospitalAffiliations,
    onApplyTimeFilter: trackFilterClickSpecialHours,
    onCheckOption: checkFacetOption,
    onClearOptions: clearManyFacetOptions,
    onSelectOption: selectFacetOption,
    onTapMoreFilters: trackMoreFiltersClick,
    onUncheckOption: uncheckFacetOption,
};

export default connect(mapStatetoProps, mapDispatchToProps)(MoreFilters);
